import fetcher from 'api/fetcher';
import { AxiosError } from 'axios';
import { push } from 'connected-react-router';
import { AccountCreateError } from 'utils/constants/accounts';
import { NotificationName } from 'utils/constants/notification';
import { formatDate } from 'utils/date';

import { AccountCreateInfo, setCreateAccountErrors } from 'store/models/accounts';
import { addNotification } from 'store/models/notification';
import { AppThunkAction } from 'store/utils';

type CreateAccount = (
    setConfirmationModalVisible: (isVisible: boolean) => void,
    onlyValidation: boolean
) => AppThunkAction;

interface Error {
    errors: { key: AccountCreateError }[];
}

export const createAccount: CreateAccount = (setConfirmationModalVisible, onlyValidation) => {
    return (dispatch, getState) => {
        const {
            accountTitle,
            accountUsers,
            accountId,
            isContractSettings,
            isContractExist,
            expiredDate,
            pricePerClick,
        } = getState().accounts;
        const shouldIncludeContractFields = accountId ? isContractExist : isContractSettings;
        const body: AccountCreateInfo = {
            title: accountTitle,
            userIds: accountUsers,
            expiredDate: shouldIncludeContractFields && expiredDate ? formatDate(expiredDate) : null,
            pricePerClickInCents: shouldIncludeContractFields && pricePerClick ? pricePerClick * 100 : null,
        };

        if (accountId) {
            body.id = accountId;
        }

        return fetcher[accountId ? 'put' : 'post'](`/api/v1/account?onlyValidation=${onlyValidation.toString()}`, body)
            .then(() => {
                if (onlyValidation) {
                    setConfirmationModalVisible(true);
                } else {
                    dispatch(push('/new/accounts/control'));
                    dispatch(
                        addNotification(
                            accountId ? NotificationName.AccountEditSuccess : NotificationName.AccountCreateSuccess
                        )
                    );
                }
            })
            .catch((err: AxiosError<Error>) => {
                if (err?.response?.status === 400) {
                    dispatch(setCreateAccountErrors(err.response.data.errors.map((item) => item.key)));
                }
            });
    };
};
